import { render, staticRenderFns } from "./prolist.vue?vue&type=template&id=1e70b3a8&scoped=true&"
import script from "./prolist.vue?vue&type=script&lang=js&"
export * from "./prolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e70b3a8",
  null
  
)

export default component.exports